var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMale = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "-283 396.8 28.6 49.1",
    enableBackground: "new -283 396.8 28.6 49.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F8F8F",
    d: "M-254.4,415.6v11.6c0,0.7-0.3,1.4-0.8,1.9s-1.2,0.8-1.9,0.8c-0.7,0-1.4-0.3-1.9-0.8s-0.8-1.2-0.8-1.9v-9.8 h-1.8v25.4c0,0.9-0.3,1.6-0.9,2.2s-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9s-0.9-1.3-0.9-2.2v-13h-1.8v13c0,0.9-0.3,1.6-0.9,2.2 s-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9s-0.9-1.3-0.9-2.2v-25.5h-1.8v9.8c0,0.7-0.3,1.4-0.8,1.9c-0.5,0.6-1.2,0.8-1.9,0.8 c-0.7,0-1.4-0.3-1.9-0.8s-0.8-1.1-0.8-1.8v-11.6c0-1.5,0.5-2.8,1.6-3.8c1-1,2.3-1.6,3.8-1.6h17.9c1.5,0,2.8,0.5,3.8,1.6 C-254.9,412.8-254.4,414.1-254.4,415.6z M-264.3,398.6c1.2,1.2,1.8,2.7,1.8,4.4c0,1.7-0.6,3.2-1.8,4.4c-1.2,1.2-2.7,1.8-4.4,1.8 c-1.7,0-3.2-0.6-4.4-1.8c-1.3-1.1-1.9-2.6-1.9-4.4c0-1.8,0.6-3.2,1.9-4.4c1.2-1.2,2.7-1.8,4.4-1.8 C-267,396.8-265.5,397.4-264.3,398.6z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMale, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/male.a7d1f9b9.svg";
export { ForwardRef as ReactComponent };